// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.storage_CreateBucketModal_label__6D-Sg {
  margin-bottom: 4px;
  color: var(--color-grey-08);
  font-size: 14px;
  line-height: 1.2;
}

.storage_CreateBucketModal_dropdown__ONC5q.SkyPortalDropdown.--outlined .MuiOutlinedInput-input {
  border-radius: 2px;
  background: var(--color-white);
  box-shadow: 2px 2px 5px #b8b8b8, -2px -2px 5px #fff;
}

.storage_CreateBucketModal_controls__1fKyV > * {
  flex: 1 1;
}
`, "",{"version":3,"sources":["webpack://./src/containers/BucketsPageContent/modals/CreateBucketModal/CreateBucketModal.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,mDAAmD;AACrD;;AAEA;EACE,SAAO;AACT","sourcesContent":[".label {\n  margin-bottom: 4px;\n  color: var(--color-grey-08);\n  font-size: 14px;\n  line-height: 1.2;\n}\n\n.dropdown:global(.SkyPortalDropdown.--outlined) :global(.MuiOutlinedInput-input) {\n  border-radius: 2px;\n  background: var(--color-white);\n  box-shadow: 2px 2px 5px #b8b8b8, -2px -2px 5px #fff;\n}\n\n.controls > * {\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `storage_CreateBucketModal_label__6D-Sg`,
	"dropdown": `storage_CreateBucketModal_dropdown__ONC5q`,
	"controls": `storage_CreateBucketModal_controls__1fKyV`
};
export default ___CSS_LOADER_EXPORT___;
